import axios, { CancelToken, ResponseType } from "axios";
import Qs from "qs";
import { Service } from "axios-middleware";
import { setHeader } from "./middleware/headerMiddleware";
import store from "../store";
import { showError } from "../store/actions/feedback";
import { ERRORS, ROUTES } from "../components/constants/user-info.const";
import {
  appendTokenToHeader,
  clearAuthData,
} from "./authService";

const service = new Service(axios);

service.register({
  // Service middleware
  onRequest(config: any) {
    setHeader(config);
    return config;
  },
  onSync(promise: unknown) {
    return promise;
  },
  onResponse(response: unknown) {
    return response;
  },
});

const instance = axios.create({
   baseURL: `${process.env.REACT_APP_DEV_SERVER_URL}cbapi/app.php/`
});

export const getResource = <T>(
  subUrl: any,
  cancelToken?: CancelToken,
  params?: any,
  rawResponse = false,
  responseType: ResponseType = "json"
) => {
  return requestHandler<T>(
    "get",
    subUrl,
    undefined,
    cancelToken,
    params,
    undefined,
    rawResponse,
    responseType
  );
};

export const postResource = <T>(
  subUrl: string,
  body?: any,
  cancelToken?: CancelToken
) => {
  return requestHandler<T>("post", subUrl, body, cancelToken);
};

export const patchResource = <T>(
  subUrl: any,
  body: any,
  cancelToken?: CancelToken
) => {
  return requestHandler<T>("patch", subUrl, body, cancelToken);
};

export const putResource = (
  subUrl: any,
  body: any,
  cancelToken?: CancelToken
) => {
  return requestHandler("put", subUrl, body, cancelToken);
};

const requestHandler = <T>(
  method: any,
  subUrl: any,
  body: any,
  cancelToken?: CancelToken,
  params?: any,
  headers?: any,
  rawResponse = false,
  responseType: ResponseType = "json"
): Promise<T> => {
  return new Promise((resolve, reject) => {
    instance
      .request({
        method: method,
        url: subUrl,
        data: body,
        cancelToken,
        params,
        responseType,
        headers,
        paramsSerializer: (params) => Qs.stringify(params, { indices: false }),
      })
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        const errorCode = error?.response?.status || null;
        const errorData = error.response?.data;
        const { feedback } = store.getState();
        if (errorData?.message === ERRORS.expiredToken) {
          window.location.hash = '#' + ROUTES.expiredLink;
          clearAuthData();
          return;
        }
        if (error.response && error.response.status === 401) {
          if (window.location.hash === "") {
            reject({
              status: errorData,
              statusText: errorData?.message || errorData?.error,
              errors: errorData?.errors || null,
            });
            return;
          }
          // Logout user
          window.location.hash = "";
          appendTokenToHeader();
          clearAuthData();
          return;
        }
        if (!error.response) {
          reject();
          return;
        }
        
        // TO DO- 5xx pattern match
        if (errorCode >= 500 && !feedback?.error?.showError) {
          store.dispatch(
            showError({
              errorCode: errorCode,
              showError: true,
            })
          );
          return;
        }
       reject({
          status: errorData,
          statusText: errorData?.message || errorData?.error,
          errors: errorData?.errors || null,
        });
      });
  });
};
